import {
  OperatorFragmentFragment,
  OperatorValueType as ApiOperatorValueType,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { ApiOperatorCode, Operator, OperatorCode, OperatorValueType } from "src/types/operator";

export const operatorCodeMapping: { [key in ApiOperatorCode]: OperatorCode } = {
  EqualsCurrent: "equalsCurrent",
  NotEqualCurrent: "notEqualCurrent",
  EqualsValue: "equalsValue",
  NotEqualsValue: "notEqualsValue",
  Empty: "empty",
  NonEmpty: "nonEmpty",
  GreaterThanValue: "greaterThanValue",
  GreaterOrEqualThanValue: "greaterOrEqualThanValue",
  LowerThanValue: "lowerThanValue",
  LowerOrEqualThanValue: "lowerOrEqualThanValue",
  Contains: "contains",
  NotContains: "notContains",
  IsTrue: "isTrue",
  NotTrue: "notTrue",
  EqualsProperty: "equalsProperty",
  NotEqualsProperty: "notEqualsProperty",
  GreaterThanProperty: "greaterThanProperty",
  GreaterOrEqualThanProperty: "greaterOrEqualThanProperty",
  LowerThanProperty: "lowerThanProperty",
  LowerOrEqualThanProperty: "lowerOrEqualThanProperty",
  ContainsProperty: "containsProperty",
  NotContainsProperty: "notContainsProperty",
  In: "in",
  NotIn: "notIn",
};

export const mapToOperatorCode = (apiOperatorCode: ApiOperatorCode): OperatorCode => {
  return operatorCodeMapping[apiOperatorCode];
};

const apiOperatorCodeReverseMapping = Object.entries(operatorCodeMapping).reduce(
  (reverseMap, [apiOperatorCode, operatorCode]) => {
    reverseMap[operatorCode] = apiOperatorCode as ApiOperatorCode;
    return reverseMap;
  },
  {} as { [key in OperatorCode]: ApiOperatorCode }
);

export const mapToApiOperatorCode = (operatorCode: OperatorCode): ApiOperatorCode => {
  return apiOperatorCodeReverseMapping[operatorCode];
};

export const OPERATOR_VALUE_TYPE_MAP: { [key in ApiOperatorValueType]: OperatorValueType } = {
  ARGUMENT: "argument",
  NONE: "none",
  SAME_AS_CURRENT: "sameAsCurrent",
  PROPERTY: "property",
  ARGUMENT_LIST: "argumentList",
};

export const mapToOperator = (operator: OperatorFragmentFragment): Operator => {
  return {
    code: mapToOperatorCode(operator.code as ApiOperatorCode),
    operatorValueType: OPERATOR_VALUE_TYPE_MAP[operator.operatorValueType],
  };
};
